import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpEvent,
  HttpRequest,
  HttpHandler,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { LoggerService } from '../utility-services/logger.service';

@Injectable()
export class SpHttpErrorInterceptor implements HttpInterceptor {
  duplicatePasswordMessage = 'PasswordHistoryError: Password has previously been used';
  constructor(private router: Router, private loggerService: LoggerService) {}
  intercept(req: HttpRequest<Request>, next: HttpHandler): Observable<HttpEvent<Request>> {
    return next
      .handle(req)

      .pipe(
        retry(1),

        catchError((error: HttpErrorResponse, _caught: Observable<any>) => {
          let errorMessage = '';

          if (error.error instanceof ErrorEvent) {
            // client-side error

            errorMessage = `Error (client-side-error): ${error.error.message}`;
          } else {
            // server-side error

            errorMessage = `Error Code (server-side-error): ${error.status}\nMessage: ${error.message} ${error.error?.ResponseStatus?.Message}`;
          }

          // alert(errorMessage);

          console.log(errorMessage);
          this.loggerService.error(errorMessage);
          if (error?.error?.ResponseStatus?.Message !== this.duplicatePasswordMessage)
            this.router.navigateByUrl('error-page');

          throw error;

          //return of(errorMessage);
        })
      );
  }
}
